(function(angular, Object) {
    'use strict';

    var blockedSlotBehavior = {};
    Object.defineProperties(blockedSlotBehavior, {
        None: {
            value: 'None',
            writable: false,
            enumerable: true,
            configurable: false,
        },
        Override: {
            value: 'Override',
            writable: false,
            enumerable: true,
            configurable: false,
        },
        BookInAddition: {
            value: 'BookInAddition',
            writable: false,
            enumerable: true,
            configurable: false,
        },
    });


    angular.module('aprima-provider-api').constant('BlockedSlotBehavior', blockedSlotBehavior);
})(window.angular, window.Object);
